

import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  IconButton,
  Tooltip,
  Link
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';
import config from '../config';

const CalendlyLink = () => {
  const [calendlyLink, setCalendlyLink] = useState('');

  useEffect(() => {
    const fetchCalendlyLink = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error('You are not logged in.');
        return;
      }

      try {
        const response = await fetch(`${config.backendUrl}/api/calendly-link`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();
        if (response.ok) {
          setCalendlyLink(data.calendlyLink);
        } else {
          toast.error('Failed to fetch Calendly link.');
        }
      } catch (error) {
        toast.error('Error fetching Calendly link.');
      }
    };

    fetchCalendlyLink();
  }, []);

  const handleCopy = () => {
    if (calendlyLink) {
      navigator.clipboard.writeText(calendlyLink);
      toast.success('Calendly link copied to clipboard!');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center', backgroundColor: 'transparent', boxShadow: 'none' }}>
        <Typography variant="h6" gutterBottom>
        Click on this link to schedule a meeting with our team:
        </Typography>

        {calendlyLink ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Link href={calendlyLink} target="_blank" rel="noopener" underline="hover" sx={{ color: 'primary.main' }}>
              {calendlyLink}
            </Link>
            <Tooltip title="Copy to clipboard">
              <IconButton onClick={handleCopy}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Box>
        ) : (
          <Typography variant="body1">Loading...</Typography>
        )}
      </Paper>
    </Container>
  );
};

export default CalendlyLink;
